import {Paginator as SystemPaginator} from 'components/system/paginator';
import {Select} from 'components/system/select';
import {pageSizeOptions} from 'utils/question_list';
import styles from './question_table_paginator.module.css';

export const QuestionTablePaginator = ({questions, config, onConfigChange}: Props) => {
  return (
    <div className={styles.paginator}>
      <SystemPaginator
        page={config.page}
        pageSize={config.pageSize}
        totalItems={questions.length}
        onChange={(page) => onConfigChange({...config, page})}
      />
      <Select
        size='sm'
        placeholder='Questions per page'
        options={pageSizeOptions}
        value={config.pageSize}
        onChange={(pageSize) => onConfigChange({...config, page: 0, pageSize})}
      />
    </div>
  );
};

type Props = {
  questions: Question[];
  config: QuestionListConfig;
  onConfigChange: (config: QuestionListConfig) => void;
};
